export const approvalInfoViewAction = "APPROVAL/INFO_VIEW";
export const approvalInfoViewSuccessAction = "APPROVAL/INFO_VIEW/SUCCESS";
export const approvalInfoViewFailAction = "APPROVAL/INFO_VIEW/FAIL";
export const approvalInfoViewResetAction = "APPROVAL/INFO_VIEW/RESET";
